import { useCallback } from 'react';
import { useLang } from 'hooks/lang';

import { Project } from 'entities';

import { Modal } from 'components/Blocks';

import { RepriceRequestSuccess } from './Success';
import { RequestRepriceForm } from './RequestForm';
import { ApproveForm } from './ApproveForm';

import { useProjectProfile } from '../../context';
import { ProjectOptionOverlayProps } from '../createProjectOption';

const flowToComponents: { [key in Exclude<Project['reprice'], undefined>]: () => JSX.Element } = {
  REQUESTED: RepriceRequestSuccess,

  COMPLETED: RequestRepriceForm,

  PENDING_APPROVAL: ApproveForm,
};

export function ManageCostsModal({ isOpen, close }: ProjectOptionOverlayProps) {
  const { project } = useProjectProfile();

  const { t } = useLang();

  const { reprice } = project;

  const closeModal = useCallback(() => {
    close();
  }, [close]);

  const FlowComponent = flowToComponents[reprice || 'COMPLETED'];

  return (
    <Modal
      close={closeModal}
      isOpen={isOpen}
      width="min(90vw, 960px)"
      title={t('manage-costs')}
      className="overflow-y-auto"
    >
      <FlowComponent />
    </Modal>
  );
}
